import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';
import RegisterFinalizeReducer from './RegisterFinalizeReducer';
import { registerFinalizeReducerKey } from './RegisterFinalizeConstants';
import RegisterFinalize from './RegisterFinalize';
import { init, setData, submit, skip, resetState } from './RegisterFinalizeActions';
import {
  ipAddress as ipAddressSelector,
  isLoading as isLoadingSelector,
  data as dataSelector,
  marketingInfo as marketingInfoSelector,
  registerFinalizeFail as registerFinalizeFailSelector,
} from './RegisterFinalizeSelectors';
import { withCombinedRouteParams } from '../../../AppRoutes/ConnectedRoute';

const mapStateToProps = (state) => ({
  ipAddress: ipAddressSelector(state),
  isLoading: isLoadingSelector(state),
  data: dataSelector(state),
  marketingInfo: marketingInfoSelector(state),
  registerFinalizeFail: registerFinalizeFailSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  setData: (data) => dispatch(setData(data)),
  init: () => dispatch(init()),
  submit: () => dispatch(submit()),
  skip: () => dispatch(skip()),
  resetState: () => dispatch(resetState()),
});

export default compose(
  withCombinedRouteParams,
  withReducer(registerFinalizeReducerKey, RegisterFinalizeReducer),
  connect(mapStateToProps, mapDispatchToProps)
)(RegisterFinalize);
